angular.module('impactx.deliverycomplaint').controller('DeliveryComplaintListCtrl', [
    '$routeParams',
    'selectedListItems',
    'AppConfiguration',
    '$scope',
    'DownloadService',
    DeliveryComplaintListCtrl
]);

function DeliveryComplaintListCtrl($routeParams, selectedListItems, AppConfiguration, $scope, DownloadService) {
    var newLink;
    if(AppConfiguration.get("useSimpleComplaint") && $routeParams.id) {
        newLink = "#/simplecomplaint/0/" + $routeParams.id
    }
    else {
        newLink = "#/deliverycomplaint/0" + ($routeParams.id ? "/" + $routeParams.id : "");
    }

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewDeliveryComplaint'
        },
        {
            label: "exportPositions",
            action: exportPositionsAsExcel,
            condition: selectedListItems.isNoSelection,
            process: 'ViewDeliveryComplaint'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/deliverycomplaint/templates/deliverycomplaintlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/deliverycomplaint/list',
        id: "deliverycomplaintlist",
        valuesInteger: [{name: "DNH_Id", value: $routeParams.id}],
        mainAction: {
            id: "new",
            link: newLink,
            icon: "mdi-plus"
        },
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "deliverycomplaint/" + selectedListItems.getFirstSelectedId();
    }

    function exportPositionsAsExcel() {
        DownloadService.openDownloadPost('/deliverycomplaint/export/postions', {paramName: "config", paramValue: $scope.$$childHead.metaData.params.listConfig});
    }
}